export const ORDER_STATUSES = {
  NEW_ORDER: 'NEW_ORDER',
  ACCEPTED: 'ACCEPTED',
  READY: 'READY',
  DELIVERED: 'DELIVERED',
  REJECTED: 'REJECTED',
  PICKED_UP: 'PICKED_UP',
  CANCELED: 'CANCELED',
  RETURNED: 'RETURNED',
  ORDER_TIMEOUT: 'ORDER_TIMEOUT',
  UKNOWN_STATUS: 'UKNOWN_STATUS',
  ONGOING: 'ONGOING',
  COMPLETED: 'COMPLETED'
} as const

export const ORDER_STATUS_CODE = Object.freeze({
  DELETED: 0,
  ORDER_RECEIVED: 1,
  RESTAURANT_REJECTED_ORDER: 2, // this is the new value and it will replace the previous one
  RESTAURANT_ACCEPTED: 3,
  DRIVER_REJECTED: 4,
  DRIVER_ACCEPTED: 5,
  DRIVER_PICKED_UP: 6,
  ORDER_DELIVERED: 7,
  PAYMENT_COMPLETED: 8,
  CANCELLED_BY_USER: 9,
  CANCELLED_BY_ADMIN: 10,
  ORDER_TIMEOUT: 11,
  NOT_AUTHORIZED: 13,
  PAYMENT_PENDING: 14,
  SCHEDULED: 15,
  DRIVER_AT_CLIENT: 16,
  DRIVER_AT_RESTAURANT: 17
})
